/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withTranslation } from 'react-i18next';

import Alert from '../../Common/AlertContainer';
import Error from '../../Common/Error';
import { formValidator } from '../../../AppUtil/AppUtil';
import { commonStyle } from '../../Common/CommonStyle';
import UserService from '../../../Service/UserService';
import MobileButton from '../../Common/Profile/Button';
import { useMediaQuery } from 'react-responsive';
import { IIFC } from 'react-iifc';
import PwInstructionList from '../../Common/Profile/PwInstructionList';
import { ta } from 'date-fns/esm/locale';
import InputLabelMobile from '../../Common/Profile/InputLabelMobile';
import ShowPassword from '../../Common/ShowPassword';
import BasicTextField from '../../Common/BasicTextField';
import AccountService from '../../../Service/AccountService';
import { hot } from 'react-hot-loader';
const { MOBILE } = window.AppConfig.SCREEN_SIZE;
const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			_authError: '',
			_disableSaveButton: true,
			_oldPassword: true,
			_newPassword: true,
			_confirmPassword: true,
			_alert: {
				_show: false,
				_message: '',
				_severity: ''
			},
			_changePassword: {
				old_password: {
					value: '',
					placeholder: 'label.current_password',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_current_password'
						}
					},
					error_text: ''
				},
				new_password: {
					value: '',
					placeholder: 'label.new_password',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.requiredNewPassword'
						},
						pattern: {
							value: PATTERN.PASSWORD,
							errorMsg: 'error_message.password_pattern'
						}
					},
					error_text: ''
				},
				confirm_new_password: {
					value: '',
					placeholder: 'label.confirm_new_password',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_confirm_password'
						}
					},
					error_text: ''
				}
			}
		};
	}

	enableSaveButton = () => {
		this.setState({
			_disableSaveButton: false
		});
	};

	/**
	 * This function handle all input change event inside login form
	 * @returns {void}
	 */
	handelInputChange = e => {
		this.setState({
			_authError: ''
		});
		const name = e.target.name;
		const value = e.target.value;
		const forgotPasswordForm = {
			...this.state._changePassword
		};
		const updatedFormElement = {
			...forgotPasswordForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		forgotPasswordForm[name] = updatedFormElement;
		this.setState({
			_changePassword: forgotPasswordForm
		});
		if (
			this.state._changePassword.old_password.value !== '' &&
			this.state._changePassword.new_password.value !== '' &&
			name === 'confirm_new_password' &&
			value !== ''
		) {
			this.enableSaveButton();
		} else if (
			this.state._changePassword.confirm_new_password.value !== '' &&
			this.state._changePassword.new_password.value !== '' &&
			name === 'old_password' &&
			value !== ''
		) {
			this.enableSaveButton();
		} else if (
			this.state._changePassword.confirm_new_password.value !== '' &&
			this.state._changePassword.old_password.value !== '' &&
			name === 'new_password' &&
			value !== ''
		) {
			this.enableSaveButton();
		} else {
			this.setState({
				_disableSaveButton: true
			});
		}
	};

	/**
	 * This function handle submit login form
	 * @returns {Promise<void>}
	 */
	onSubmitHandler = async e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}
		this.onChangePassword();
	};

	/**
	 * This function validate all field in login form
	 */
	formValidator = () => {
		const form = {
			...this.state._changePassword
		};
		let isConfirmPassFieldValid = true;
		const [updatedForm, isFormValid] = formValidator(form);
		if (
			updatedForm.confirm_new_password.isValid &&
			updatedForm.confirm_new_password.isTouched &&
			updatedForm.confirm_new_password.value !== updatedForm.new_password.value
		) {
			updatedForm.confirm_new_password.isValid = false;
			updatedForm.confirm_new_password.error_text = 'error_message.confirmPasswordMissMatch'; // NOSONAR
			isConfirmPassFieldValid = false;
		}
		if (form.old_password.value === form.new_password.value) {
			this.setState({
				_authError: 'error_message.current_and_new_password_not_same'
			});
			isConfirmPassFieldValid = false;
		}
		this.setState({
			_changePassword: updatedForm
		});
		return isFormValid && isConfirmPassFieldValid;
	};

	clearAllFields = () => {
		const form = {
			...this.state._changePassword
		};
		form.old_password.value = '';
		form.new_password.value = '';
		form.confirm_new_password.value = '';
		this.setState({
			_changePassword: form
		});
	};

	startLoader = () => {
		this.setState({
			isLoading: true,
			_disableSaveButton: true
		});
	};

	stopLoader = () => {
		this.setState({
			isLoading: false,
			_disableSaveButton: false
		});
		this.clearAllFields();
	};

	sendPasswordChangedConfirmationNotification = async () => {
		const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER_INFO')).profile;
		const phone = currentUser.phone;

		await AccountService.sendChangedPasswordConfirmationNotify({ phone });
	};

	onChangePassword = async () => {
		try {
			this.startLoader();
			const oldPassword = this.state._changePassword.old_password.value;
			const newPassword = this.state._changePassword.new_password.value;
			const response = await UserService.changePassword(oldPassword, newPassword);
			if (response.status) {
				await this.showAlert(true, 'success', this.props.t('profile.password_successfully_sent'));
				await this.sendPasswordChangedConfirmationNotification();
			} else {
				this.setState({
					_authError: response.data
				});
			}
			this.stopLoader();
		} catch (error) {
			this.stopLoader();
			console.log(error);
			this.setState({
				_authError: error.message
			});
		}
	};

	showAlert = async (show, severity, message) => {
		const alert = {
			_show: show,
			_message: message,
			_severity: severity
		};
		await this.setState({
			_alert: alert
		});
	};

	hideAlert = async () => {
		const alert = {
			_show: false,
			_message: '',
			_severity: ''
		};
		await this.setState({
			_alert: alert
		});
	};

	render() {
		const { classes } = this.props;
		const { t } = this.props;

		const changeIconOldPassword = this.state._oldPassword === true ? false : true;
		const changeIconNewPassword = this.state._newPassword === true ? false : true;
		const changeIconConfirmPassword = this.state._confirmPassword === true ? false : true;
		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });
					return (
						<Grid id="full-wdith" item md zeroMinWidth className={isMobile && 'change_P_grid'}>
							{isMobile ? <p className="pw_ask">Would you like to change your password?</p> : null}

							<form id="pw_form" className={classes.form} noValidate onSubmit={this.onSubmitHandler}>
								<InputLabelMobile label="Current Password*" className="pw_input_label" />
								<BasicTextField
									autoComplete="old_password"
									autoFocus
									className={classes.displayFlex}
									error={
										!this.state._changePassword.old_password.isValid &&
										this.state._changePassword.old_password.isTouched
									}
									fullWidth
									helperText={
										!this.state._changePassword.old_password.isValid &&
										this.state._changePassword.old_password.isTouched
											? t(this.state._changePassword.old_password.error_text)
											: ''
									}
									type={this.state._oldPassword ? 'password' : 'text'}
									icon={
										<ShowPassword
											onClick={() => {
												this.setState({ _oldPassword: changeIconOldPassword });
											}}
											changeIcon={changeIconOldPassword}
										/>
									}
									id="old_password"
									label={isMobile ? null : t(this.state._changePassword.old_password.placeholder)}
									placeholder={'Old Password'}
									name="old_password"
									onChange={this.handelInputChange}
									value={this.state._changePassword.old_password.value}
									variant="outlined"
								/>
								<InputLabelMobile label="New Password*" className="pw_input_label" />
								<BasicTextField
									autoComplete="new_password"
									className={classes.displayFlex}
									placeholder={'New Password'}
									error={
										!this.state._changePassword.new_password.isValid &&
										this.state._changePassword.new_password.isTouched
									}
									type={this.state._newPassword ? 'password' : 'text'}
									icon={
										<ShowPassword
											onClick={() => {
												this.setState({ _newPassword: changeIconNewPassword });
											}}
											changeIcon={changeIconNewPassword}
										/>
									}
									fullWidth
									helperText={
										!this.state._changePassword.new_password.isValid &&
										this.state._changePassword.new_password.isTouched
											? t(this.state._changePassword.new_password.error_text)
											: ''
									}
									id="new_password"
									label={isMobile ? null : t(this.state._changePassword.new_password.placeholder)}
									margin={isMobile ? 'none' : 'normal'}
									name="new_password"
									onChange={this.handelInputChange}
									value={this.state._changePassword.new_password.value}
									variant="outlined"
								/>
								<InputLabelMobile label="Confirm New Password*" className="pw_input_label" />
								<BasicTextField
									autoComplete="confirm_new_password"
									className={classes.displayFlex}
									placeholder={'Confirm Password'}
									error={
										!this.state._changePassword.confirm_new_password.isValid &&
										this.state._changePassword.confirm_new_password.isTouched
									}
									fullWidth
									type={this.state._confirmPassword ? 'password' : 'text'}
									icon={
										<ShowPassword
											onClick={() => {
												this.setState({ _confirmPassword: changeIconConfirmPassword });
											}}
											changeIcon={changeIconConfirmPassword}
										/>
									}
									helperText={
										!this.state._changePassword.confirm_new_password.isValid &&
										this.state._changePassword.confirm_new_password.isTouched
											? t(this.state._changePassword.confirm_new_password.error_text)
											: ''
									}
									id="confirm_new_password"
									label={
										isMobile ? null : t(this.state._changePassword.confirm_new_password.placeholder)
									}
									name="confirm_new_password"
									onChange={this.handelInputChange}
									value={this.state._changePassword.confirm_new_password.value}
									variant="outlined"
								/>
								<Error text={t(this.state._authError)} />
								<div className={classes.blockdiv}>
									<PwInstructionList isMobile={isMobile} />
									<div className={isMobile ? 'centered_container my' : ''}>
										<MobileButton
											icon={this.state.isLoading && <CircularProgress disableShrink size={18} />}
											text={t('buttons.save')}
											className="btn-green"
											disabled={this.state._disableSaveButton}
											onClick={this.onSubmitHandler}
										/>
									</div>
									{isMobile ? null : (
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											disabled={this.state._disableSaveButton}
											onClick={this.onSubmitHandler}
											size="medium"
											type="submit"
											variant="extended">
											{t('buttons.save')} &nbsp;
											{this.state.isLoading ? (
												<CircularProgress disableShrink size={18} />
											) : (
												<ArrowForwardIcon />
											)}
										</Fab>
									)}
								</div>
							</form>
							<Alert
								message={this.state._alert._message || ''}
								onClose={this.hideAlert}
								severity={this.state._alert._severity || 'success'}
								show={this.state._alert._show || false}
							/>
						</Grid>
					);
				}}
			</IIFC>
		);
	}
}

export default hot(module)(withStyles(commonStyle)(withTranslation()(index)));
